import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section id="guides" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 text-center mb-3">
          Latest Vigorbuy Spreadsheet Guides
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-10 max-w-xl mx-auto">
          Read our in-depth Vigorbuy Spreadsheet articles covering tips, safety, product discovery strategies, and the latest updates for 2026.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-100 rounded-lg overflow-hidden hover:bg-accent-50/30 transition-colors border border-background-200 hover:border-accent-200 cursor-pointer"
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - Vigorbuy Spreadsheet Guide`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-medium px-2.5 py-1 rounded-full mb-3">
                  {article.category}
                </span>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-accent-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}